import type { VaultIconName } from '../lib/documents.js';

/**
 * The Vault's kind icons — one stroke glyph per vital-record family
 * (passport, certificate, marriage, citizenship, will, deed, ID,
 * medical, shield fallback), matched from the kind label by
 * `vaultKindIconName`. Same 24×24 stroke language as the home tiles.
 */
export function VaultKindIcon({ name }: { name: VaultIconName }) {
  const common = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.9,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    viewBox: '0 0 24 24',
    'aria-hidden': true,
  };
  switch (name) {
    case 'passport':
      return (
        <svg {...common}>
          <rect x="5" y="3" width="14" height="18" rx="2" />
          <circle cx="12" cy="10" r="3.2" />
          <path d="M9 16.5h6" />
        </svg>
      );
    case 'certificate':
      return (
        <svg {...common}>
          <circle cx="12" cy="9" r="4.5" />
          <path d="M9 12.8 7.5 20l4.5-2.4L16.5 20 15 12.8" />
        </svg>
      );
    case 'rings':
      return (
        <svg {...common}>
          <circle cx="9.5" cy="13" r="4.6" />
          <circle cx="14.5" cy="13" r="4.6" />
          <path d="M10.5 5h3l-1.5 3z" />
        </svg>
      );
    case 'flag':
      return (
        <svg {...common}>
          <path d="M5 21V4" />
          <path d="M5 5c3-2 6 1 9-1 2-1.2 4-1 5-.5V12c-1-.5-3-.7-5 .5-3 2-6-1-9 1" />
        </svg>
      );
    case 'scroll':
      return (
        <svg {...common}>
          <path d="M16 5v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2h-4" />
          <path d="M8 9h5M8 13h5M8 17h3" />
        </svg>
      );
    case 'house':
      return (
        <svg {...common}>
          <path d="M4 11 12 4l8 7" />
          <path d="M6 10v10h12V10" />
          <path d="M10 20v-5h4v5" />
        </svg>
      );
    case 'idcard':
      return (
        <svg {...common}>
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <circle cx="8.5" cy="11" r="2" />
          <path d="M6 16c.5-1.5 4.5-1.5 5 0M14 10h5M14 14h4" />
        </svg>
      );
    case 'cross':
      return (
        <svg {...common}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M12 8.5v6M9 11.5h6" />
        </svg>
      );
    case 'shield':
      return (
        <svg {...common}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M9 11.5l2 2 4-4" />
        </svg>
      );
  }
}
